module.exports = __webpack_public_path__ + "img/click.2a17b2a7.png";